const tagTypes = ["User", "Product"];

export default tagTypes;
